<template>
  <div>
    <div class="title">
      <van-icon name="arrow-left" class="lefticon" @click="goBack()" />
      <p>支付</p>
    </div>
    <van-notice-bar
      left-icon="info-o"
      text="付款后系统自动开始检测,如需帮助请联系客服"
      mode="closeable"
    />
    <div class="pay-page">
      <section class="pay-order-card">
        <div class="pay-order-header">
          <p class="pay-order-caption">订单信息</p>
        </div>
        <div class="pay-order-list">
          <div class="pay-order-row">
            <span class="pay-order-label">版本：</span>
            <strong class="pay-order-value">{{ displayVersionName }}</strong>
          </div>
          <div class="pay-order-row">
            <span class="pay-order-label">题目：</span>
            <strong class="pay-order-value">{{ currentTitle }}</strong>
          </div>
          <div class="pay-order-row">
            <span class="pay-order-label">作者：</span>
            <strong class="pay-order-value">{{ currentWriter }}</strong>
          </div>
          <div class="pay-order-row">
            <span class="pay-order-label">字数：</span>
            <strong class="pay-order-value">{{ wordsDisplay }}</strong>
          </div>
          <div class="pay-order-row">
            <span class="pay-order-label">时间：</span>
            <strong class="pay-order-value">{{ currentCreatedAt }}</strong>
          </div>
          <div class="pay-order-row pay-order-row-accent">
            <span class="pay-order-label">价格：</span>
            <strong class="pay-order-value pay-order-price">{{ orderPriceDisplay }}</strong>
          </div>
          <div class="pay-order-row" v-if="teamDiscountText">
            <span class="pay-order-label">三人成行：</span>
            <strong class="pay-order-value">{{ teamDiscountText }}</strong>
          </div>
        </div>
      </section>

      <!-- 优惠券 -->
      <!--div class="pay-coupon-block">
        <youhui :orderId="msgs.id" @callBack="callBack"></youhui>
      </div>
      <div v-if="this.code" style="margin-top: 20px">
        <van-cell
          :title="`订单原价：${currentPrice}元，卡券优惠：${fomatFloat(
            currentPrice - this.yhprice,
            2
          )}元`"
          icon="info-o"
        >
        </van-cell>
      </div-->
      <!-- 优惠券结束 -->
      <section class="pay-support-card">
        <div class="pay-support-title">支付说明</div>
        <p class="pay-support-text">
          请务必核对以上信息，支付后即开始检测，无法修改及撤回。
        </p>
      </section>

      <div class="pay-footer">
        <div class="pay-footer-main">
          <div class="pay-footer-amount">
            <span class="pay-footer-label">订单金额</span>
            <strong class="pay-footer-price">{{ payAmountDisplay }}</strong>
            <span class="pay-footer-unit">元</span>
          </div>
          <button class="zfbtn" :disabled="payLoading" @click="toPay">
            <span class="zfbtn-text">{{ payLoading ? "处理中..." : zhifuText }}</span>
          </button>
        </div>
      </div>
      <!-- </form> -->
      <van-action-sheet
        v-model="show"
        :actions="actions"
        v-if="!iswxbrowser"
        cancel-text="取消"
        @cancel="onCancel"
        @select="onselect"
      />
    </div>
  </div>
</template>
<script>
import { Toast, Dialog } from "vant";
import youhui from "@/components/youhui";
import {
  computeUnitPrice,
  formatMoney,
  formatVersionName,
  getPriceUnitLabel,
} from "@/utils/order";

export default {
  components: {
    youhui,
  },
  data() {
    return {
      orderid: "",
      msgs: {},
      iswx: "",
      weixinCode: "",
      show: false,
      actions: [{ name: "支付宝" }, { name: "微信" }],
      acctive: "",
      aciondz: "",
      Android: "",
      iswxbrowser: false,
      codes: "",
      paydata: {},
      openId: "",
      zhifuText: "支付",
      fromquery: false,
      code: "",
      yhprice: "",
      orderDetail: null,
      payLoading: false,
    };
  },
  computed: {
    displayVersionName() {
      return (
        formatVersionName(this.orderDetail && this.orderDetail.category, true) ||
        this.msgs.name
      );
    },
    currentPriceType() {
      if (this.orderDetail && this.orderDetail.category) {
        return this.orderDetail.category.price_type;
      }
      return this.msgs.pricetype;
    },
    currentPrice() {
      if (this.orderDetail && this.orderDetail.price !== undefined && this.orderDetail.price !== null) {
        return this.orderDetail.price;
      }
      return this.msgs.price;
    },
    currentWords() {
      if (this.orderDetail && this.orderDetail.words !== undefined && this.orderDetail.words !== null) {
        return this.orderDetail.words;
      }
      return this.msgs.words;
    },
    currentTitle() {
      return (this.orderDetail && this.orderDetail.title) || this.msgs.title || "";
    },
    currentWriter() {
      return (this.orderDetail && this.orderDetail.writer) || this.msgs.writer || "";
    },
    currentCreatedAt() {
      return (this.orderDetail && this.orderDetail.created_at) || this.msgs.timer || "";
    },
    wordsDisplay() {
      const words = this.currentWords || 0;
      if (String(this.currentPriceType) === "2") {
        return `${words}字`;
      }

      const unitLabel = getPriceUnitLabel(this.currentPriceType);
      return `${words}字（不足${unitLabel}按1${unitLabel}计费）`;
    },
    unitPriceDisplay() {
      const raw = this.currentPrice;
      const words = this.currentWords;
      const priceType = this.currentPriceType;
      const unitPrice = computeUnitPrice(raw, words, priceType);
      return formatMoney(unitPrice);
    },
    orderPriceDisplay() {
      const total = formatMoney(this.currentPrice) || this.currentPrice;
      const unitPrice = this.unitPriceDisplay;
      const unitLabel = getPriceUnitLabel(this.currentPriceType);

      if (!unitPrice) {
        return `${total}元`;
      }

      return `${total}元（${unitPrice}元/${unitLabel}）`;
    },
    payAmountDisplay() {
      if (this.code) {
        return formatMoney(this.yhprice) || this.yhprice;
      }

      return formatMoney(this.currentPrice) || this.currentPrice;
    },
    teamDiscountText() {
      const discount = this.orderDetail && this.orderDetail.team_discount ? this.orderDetail.team_discount : null;
      if (!discount || !discount.applied) {
        return "";
      }

      return `已享受三人成行优惠，立减${formatMoney(discount.amount) || discount.amount}元`;
    },
  },
  created() {
    this.msgs = this.$route.query;
    this.orderid = this.msgs.id;
    const ua = window.navigator.userAgent.toLowerCase();
    //判断是否是微信内置浏览器
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      this.iswxbrowser = true;
      this.openId = window.sessionStorage.getItem("openId");
    } else {
      this.iswxbrowser = false;
      window.sessionStorage.removeItem("openId");
    }
    this.logFrontendEvent("pay_page_created", {
      meta: {
        iswxbrowser: this.iswxbrowser,
        has_openid: !!this.openId,
        has_token: !!window.sessionStorage.getItem("Token"),
      },
    });
    this.loadOrderDetail();
  },
  beforeRouteEnter(to, from, next) {
    let is_from = false;
    if (from.path == "/queryorder") {
      is_from = true;
    }
    next((vm) => {
      // 通过 `vm` 访问组件实例
      if (!from.name) {
        if (window.sessionStorage.getItem("Android")) {
          Dialog.alert({
            message: "已完成支付",
          }).then(() => {
            // on close
            vm.topayPage();
          });
        }
      }
      if (is_from) {
        vm.fromquery = is_from;
        Dialog.alert({
          message: "未支付订单不可查看报告，请完成支付",
        }).then(() => {
          // on close
        });
      }
    });
  },
  mounted() {},
  methods: {
    logFrontendEvent(event, payload = {}) {
      if (!this.$http || !this.$http.postFrontendLog) {
        return;
      }

      this.$http.postFrontendLog({
        channel: "h5",
        page: "/pay",
        event,
        order_id: this.orderid || this.msgs.id || "",
        order_no: this.msgs.orderid || "",
        status: this.orderDetail && this.orderDetail.status ? this.orderDetail.status : "",
        user_agent: window.navigator.userAgent,
        meta: {
          iswxbrowser: this.iswxbrowser,
          has_openid: !!this.openId,
          ...payload.meta,
        },
      }).catch(() => {});
    },
    loadOrderDetail() {
      if (!this.msgs.id && !this.msgs.orderid) {
        this.logFrontendEvent("pay_load_order_skipped", {
          meta: {
            reason: "missing_order_id",
          },
        });
        return;
      }

      const hasToken = !!window.sessionStorage.getItem("Token");
      const request =
        hasToken && this.msgs.id
          ? this.$http.getOrderDetail(this.msgs.id)
          : this.$http.getIsPhone(this.msgs.orderid);

      request
        .then((res) => {
          this.orderDetail = res.data;
          this.logFrontendEvent("pay_order_loaded", {
            meta: {
              loaded_by: hasToken && this.msgs.id ? "detail" : "orderid_lookup",
              order_status: res.data && res.data.status ? res.data.status : "",
            },
          });
        })
        .catch((error) => {
          this.logFrontendEvent("pay_order_load_failed", {
            meta: {
              message:
                (error &&
                  error.response &&
                  error.response.data &&
                  (error.response.data.message || error.response.data.error)) ||
                (error && error.message) ||
                "unknown",
            },
          });
        });
    },
    fomatFloat(num, n) {
      var f = parseFloat(num);
      if (isNaN(f)) {
        return false;
      }
      f = Math.round(num * Math.pow(10, n)) / Math.pow(10, n); // n 幂
      var s = f.toString();
      var rs = s.indexOf(".");
      //判定如果是整数，增加小数点再补0
      if (rs < 0) {
        rs = s.length;
        s += ".";
      }
      while (s.length <= rs + n) {
        s += "0";
      }
      return s;
    },
    //价格回调
    callBack(e) {
      this.code = e.code;
      this.yhprice = e.yhprice;
    },
    goBack() {
      this.$router.go(-1);
    },
    topayPage() {
      window.sessionStorage.removeItem("Android");
      this.$http.getIsPhone(this.msgs.orderid).then((res) => {
        if (res.data.phone) {
          this.$router.push(`/queryorder?phone=${res.data.phone}`);
        } else {
          this.$router.push("/report");
        }
      });
    },
    onCancel() {
      this.show = false;
      this.payLoading = false;
    },
    checkDuplicatePay(duplicateConfirmed) {
      return this.$http.duplicatePayCheck(this.orderid, duplicateConfirmed);
    },
    handleDuplicatePayError(error, retryFn) {
      const responseData = error && error.response && error.response.data ? error.response.data : null;
      const duplicate = responseData && responseData.duplicate_file ? responseData.duplicate_file : null;

      if (!duplicate) {
        return false;
      }

      if (duplicate.blocked) {
        this.payLoading = false;
        Toast.fail((responseData && (responseData.message || responseData.msg)) || "该文件与上次提交信息一致，不能继续支付");
        return true;
      }

      if (!duplicate.need_confirm) {
        return false;
      }

      this.payLoading = false;
      Dialog.confirm({
        title: "重复文件提醒",
        message: duplicate.message || "该文件已被检测过，请确认是否要继续支付，重复检测不支持退款",
        confirmButtonText: "确定支付",
        cancelButtonText: "取消",
      })
        .then(() => {
          retryFn();
        })
        .catch(() => {});

      return true;
    },
    toPay() {
      if (this.payLoading) {
        this.logFrontendEvent("pay_click_ignored_loading");
        return;
      }

      this.payLoading = true;
      this.logFrontendEvent("pay_click", {
        meta: {
          current_price: this.currentPrice,
          code: this.code || "",
        },
      });
      if (String(this.currentPrice) == "0.00") {
        this.$http.freePay(this.orderid).then((res) => {
          this.logFrontendEvent("pay_free_success");
          Toast.success("提交成功");
          this.$router.replace("/report");
        }).finally(() => {
          this.payLoading = false;
        });
        return;
      }
      if (!this.iswxbrowser) {
        this.logFrontendEvent("pay_open_action_sheet");
        this.show = true;
        this.payLoading = false;
      } else {
        this.show = false;
        this.logFrontendEvent("pay_start_wechat_jsapi");
        this.toWxPay(false);
      }
    },
    getUrl(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    onselect(e) {
      if (this.payLoading) {
        return;
      }

      this.payLoading = true;
      switch (e.name) {
        case "支付宝":
          this.show = false;
          this.checkDuplicatePay(false)
            .then(() => {
              window.location.href = `https://www.wanfangtest.com/payments/${this.msgs.id}/alipay_wap?code=${this.code}`;
            })
            .catch((err) => {
              if (this.handleDuplicatePayError(err, () => {
                this.payLoading = true;
                this.checkDuplicatePay(true)
                  .then(() => {
                    window.location.href = `https://www.wanfangtest.com/payments/${this.msgs.id}/alipay_wap?code=${this.code}&duplicate_confirmed=1`;
                  })
                  .catch(() => {
                    this.payLoading = false;
                  });
              })) {
                return;
              }

              this.payLoading = false;
            });
          return;
        case "微信":
          this.toH5WechatPay(false);
          break;
        default:
          this.payLoading = false;
          break;
      }
    },
    toH5WechatPay(duplicateConfirmed) {
      this.logFrontendEvent("pay_start_wechat_h5", {
        meta: {
          duplicate_confirmed: !!duplicateConfirmed,
        },
      });
      this.checkDuplicatePay(duplicateConfirmed)
        .then(() => {
          const url = `https://www.wanfangtest.com/payments/${this.msgs.id}/wechat_wap?code=${this.code}${duplicateConfirmed ? "&duplicate_confirmed=1" : ""}`;
          this.logFrontendEvent("pay_wechat_h5_redirect", {
            meta: {
              duplicate_confirmed: !!duplicateConfirmed,
              url,
            },
          });
          window.location.href = url;
          window.sessionStorage.setItem("Android", "true");
          this.show = false;
          setTimeout(() => {
            Dialog.alert({
              message: "已完成支付",
            }).then(() => {
              this.topayPage();
            });
          }, 3000);
        })
        .catch((err) => {
          this.logFrontendEvent("pay_wechat_h5_failed", {
            meta: {
              duplicate_confirmed: !!duplicateConfirmed,
              message:
                (err &&
                  err.response &&
                  err.response.data &&
                  (err.response.data.message || err.response.data.error)) ||
                (err && err.message) ||
                "unknown",
            },
          });
          if (this.handleDuplicatePayError(err, () => {
            this.payLoading = true;
            this.toH5WechatPay(true);
          })) {
            return;
          }

          this.payLoading = false;
        });
    },
    toWxPay(duplicateConfirmed) {
      this.logFrontendEvent("pay_bridge_request_start", {
        meta: {
          duplicate_confirmed: !!duplicateConfirmed,
          openid_present: !!this.openId,
        },
      });
      this.$http
        .getTowxPay({
          id: this.orderid,
          openid: this.openId,
          code: this.code,
          duplicate_confirmed: duplicateConfirmed ? 1 : 0,
        })
        .then((res) => {
          this.paydata = res;
          this.logFrontendEvent("pay_bridge_request_success", {
            meta: {
              duplicate_confirmed: !!duplicateConfirmed,
              has_appid: !!(res && res.appId),
              has_package: !!(res && res.package),
            },
          });
          this.invokeWechatPay(this.paydata);
        })
        .catch((err) => {
          this.logFrontendEvent("pay_bridge_request_failed", {
            meta: {
              duplicate_confirmed: !!duplicateConfirmed,
              message:
                (err &&
                  err.response &&
                  err.response.data &&
                  (err.response.data.message || err.response.data.error)) ||
                (err && err.message) ||
                "unknown",
            },
          });
          if (this.handleDuplicatePayError(err, () => {
            this.payLoading = true;
            this.toWxPay(true);
          })) {
            return;
          }

          this.payLoading = false;
          console.log(err);
        });
    },
    invokeWechatPay(paydata) {
      if (typeof window.WeixinJSBridge === "undefined") {
        this.logFrontendEvent("pay_bridge_wait_ready");
        const readyHandler = () => {
          this.logFrontendEvent("pay_bridge_ready_event");
          this.onBridgeReady(paydata);
        };

        if (document.addEventListener) {
          document.addEventListener("WeixinJSBridgeReady", readyHandler, {
            once: true,
          });
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", readyHandler);
          document.attachEvent("onWeixinJSBridgeReady", readyHandler);
        }

        return;
      }

      this.onBridgeReady(paydata);
    },
    onBridgeReady(paydata) {
      this.logFrontendEvent("pay_bridge_invoke");
      window.WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: paydata.appId, //公众号名称，由商户传入
          timeStamp: paydata.timeStamp, //时间戳，自1970年以来的秒数
          nonceStr: paydata.nonceStr, //随机串
          package: paydata.package,
          signType: paydata.signType, //微信签名方式：
          paySign: paydata.paySign, //微信签名
        },
        (res) => {
          this.logFrontendEvent("pay_bridge_callback", {
            meta: {
              err_msg: res && res.err_msg ? res.err_msg : "",
            },
          });
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            Toast.success("支付成功");
            this.$router.replace("/report");
            // 使用以上方式判断前端返回,微信团队郑重提示：
            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
            this.payLoading = false;
            Toast.fail("支付失败");
          } else {
            //支付失败
            console.log("fail");
            this.payLoading = false;
            Toast.fail("支付失败");
          }
        }
      );
    },
  },
};
</script>

<style scoped>
.pay-page {
  padding: 0.24rem 0.24rem 1.25rem;
}
.title {
  display: flex;
  background: #228ef7;
}
.pay-order-card {
  margin-top: 0.08rem;
  padding: 0.28rem;
  border-radius: 0.22rem;
  background: #fff;
  box-shadow: 0 0.12rem 0.32rem rgba(34, 142, 247, 0.08);
}
.pay-order-header {
  margin-bottom: 0.22rem;
}
.pay-order-caption {
  margin: 0;
  font-size: 0.24rem;
  color: #8b95a7;
}
.pay-order-version {
  margin: 0.08rem 0 0;
  font-size: 0.35rem;
  line-height: 1.45;
  color: #1f2937;
  word-break: break-word;
}
.pay-order-list {
  border-top: 1px solid #edf2f7;
}
.pay-order-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.28rem;
  padding: 0.24rem 0;
  border-bottom: 1px solid #edf2f7;
}
.pay-order-row:last-child {
  border-bottom: none;
}
.pay-order-row-accent {
  margin-top: 0.04rem;
  padding: 0.22rem 0.2rem;
  border: none;
  border-radius: 0.18rem;
  background: #fff6f2;
}
.pay-order-label {
  flex-shrink: 0;
  font-size: 0.28rem;
  color: #8b95a7;
  font-weight: 600;
  line-height: 1.7;
}
.pay-order-value {
  flex: 1;
  font-size: 0.29rem;
  line-height: 1.6;
  color: #1f2937;
  word-break: break-word;
  text-align: right;
}
.pay-order-price {
  color: #f5602a;
}
.pay-coupon-block {
  margin-top: 0.3rem;
}
.pay-support-card {
  margin-top: 0.3rem;
  padding: 0.28rem;
  border-radius: 0.22rem;
  background: linear-gradient(180deg, #f8fbff 0%, #ffffff 100%);
  border: 1px solid #dbeafe;
}
.pay-support-title {
  font-size: 0.3rem;
  font-weight: 600;
  color: #1f2937;
}
.pay-support-text {
  margin: 0.14rem 0 0;
  font-size: 0.26rem;
  line-height: 1.75;
  color: #6b7280;
}
.pay-support-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 2.2rem;
  height: 0.74rem;
  margin-top: 0.24rem;
  padding: 0 0.28rem;
  border-radius: 999px;
  background: rgba(34, 142, 247, 0.1);
  color: #228ef7;
  font-size: 0.27rem;
  font-weight: 600;
}
.lefticon {
  line-height: 0.8rem;
  padding: 0 0.3rem;
  color: #fff;
  font-size: 0.4rem;
}
.title p {
  height: 0.8rem;
  text-align: center;
  line-height: 0.8rem;
  color: #fff;
  flex: 0.85;
}

.pay-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 0.18rem 0.24rem calc(0.18rem + env(safe-area-inset-bottom));
  box-sizing: border-box;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #eef6ff 100%);
}
.pay-footer-main {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.18rem 0.2rem 0.18rem 0.28rem;
  border-radius: 0.26rem;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 0.12rem 0.34rem rgba(34, 142, 247, 0.12);
  backdrop-filter: blur(10px);
}
.zfbtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 2.36rem;
  height: 0.92rem;
  padding: 0 0.36rem;
  background: linear-gradient(135deg, #228ef7 0%, #4aa8ff 100%);
  border: none;
  border-radius: 999px;
  color: #fff;
  box-shadow: 0 0.1rem 0.24rem rgba(34, 142, 247, 0.22);
}
.zfbtn[disabled] {
  background: #9ca3af;
  box-shadow: none;
}
.zfbtn-text {
  color: #fff;
  font-size: 0.33rem;
  font-weight: 600;
}
.pay-footer-amount {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  min-width: 0;
}
.pay-footer-label {
  margin-right: 0.14rem;
  font-size: 0.26rem;
  color: #8b95a7;
}
.pay-footer-price {
  font-size: 0.48rem;
  line-height: 1;
  color: #f5602a;
}
.pay-footer-unit {
  margin-left: 0.06rem;
  font-size: 0.26rem;
  color: #f5602a;
}
</style>
